import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import "../Assistant/Assistant.css";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { getCampaign } from "../../services/Campaign";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Loader from "../Loader";
import { useAuth } from "../../context/AuthContext";

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#2F024E",
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    border: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(226, 186, 253, 0.30)",
    border: "none",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: "none",
  },
}));

const drawerWidth = 300;
const Campaign = () => {
  const notify = () => toast.success("Setup Completed");
  const remove = () => toast.success("Deleted successfully");

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);

  const navigate = useNavigate();

  const [allCampaign, setAllCampaign] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const handleSearch = () => {
    // Add logic to handle search
  };
  // TablePagination-start
  const [page, setPage] = useState(0); // Page state (0-based index)
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page state
  const [totalPages, setTotalPages] = useState(0); // Total pages from backend

 
  const handleChangePage = (event, newPage) => {
    setPage(newPage); // Update current page
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value); // Update rows per page
    setPage(0); // Reset to page 0 when rows per page change
  };

  const { userResponse } = useAuth();
  const [startDate, setStartDate] = useState(dayjs().startOf("day")); // Start of today
  const [endDate, setEndDate] = useState(dayjs().endOf("day"));
  const [statusFilter, setStatusFilter] = useState("");
  const[load,setLoad]=useState(true);
  useEffect(() => {
    // if(userResponse?.haveCampaign===true){
    getCampaignList();
    const intervalId = setInterval(() => {
  getCampaignListLoad();
}, 10000);

return () => clearInterval(intervalId);

    // }
  }, []);


  const getCampaignListLoad = async () => {
    const response = await getCampaign();
    if (response?.data?.success === true) {
      setAllCampaign(response.data.result?.data);
      setTotalPages(response.data.result?.totalPages); // Set the total pages from the backend

   
    } 
  };

  const getCampaignList = async () => {
    setLoad(true);
    const response = await getCampaign();
    if (response?.data?.success === true) {
      setAllCampaign(response.data.result?.data);
      setTotalPages(response.data.result?.totalPages); // Set the total pages from the backend

      setLoad(false);
    } else {
      setLoad(false);
    }
  };
  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const filteredCampaignList = allCampaign?.filter((campaign) => {
    const callDate = dayjs(campaign.date); // Assuming call.date is in a valid date format
    const isDateInRange = callDate.isBetween(startDate, endDate, null, "[]");
    const isStatusMatching = statusFilter
      ? campaign.status === statusFilter
      : true;
    // return callDate.isBetween(startDate, endDate, null, "[]"); // Inclusive of startDate and endDate
    return isDateInRange && isStatusMatching;
  });

  const displayedRows = filteredCampaignList?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);


  if(load) return <Loader/>


  return (
    <div>
      {/* {userResponse.haveCampaign===true && <Loader/>} */}
      {/* {load===true &&  <Loader /> } */}
     
      {allCampaign?.length > 0 ? (
        <div className="CallHistoryTable">
          {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
            <SideBar /> */}

            {/* <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: isLgUp ? 5 : 1,
                width: { sm: `calc(100% - ${drawerWidth}px)` },
                marginTop: isLgUp ? "0px" : "80px",
              }}
            > */}
              <h3>Campaigns</h3>
              <div className="graient-btn mt-30">
                <Button
                  className="display-1"
                  onClick={() => {
                    navigate("/Create-campaign");
                  }}
                >
                  CREATE NEW CAMPAIGN <AddIcon />
                </Button>
              </div>
              <Grid2
                container
                spacing={1}
                sx={{ alignItems: "center", marginTop: "20px" }}
              >
                <Grid2
                  item
                  size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                  className="mb-20"
                >
                  <Grid2 container spacing={2} sx={{ alignItems: "center" }}>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 3 }}>
                      <div className="input-common DatePicker-button">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DemoItem>
                              <label>Start Date</label>
                              {/* <DatePicker defaultValue={dayjs("2022-04-17")} /> */}
                              <DatePicker
                                value={startDate}
                                onChange={(newValue) => setStartDate(newValue)}
                              />
                            </DemoItem>
                          </DemoContainer>
                        </LocalizationProvider>
                      </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 3 }}>
                      <div className="input-common DatePicker-button">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DemoItem>
                              <label>End Date</label>
                              {/* <DatePicker defaultValue={dayjs("2022-04-17")} /> */}
                              <DatePicker
                                value={endDate}
                                onChange={(newValue) => setEndDate(newValue)}
                              />
                            </DemoItem>
                          </DemoContainer>
                        </LocalizationProvider>
                      </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                      <div className="RadioGroup-Completed">
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={statusFilter}
                          onChange={handleStatusChange}
                        >
                          {/* <div className="green-color-input display-1">
                            {" "}
                            <FormControlLabel
                              value="female"
                              control={<Radio />}
                            />
                            <p>Completed</p>
                          </div>
                          <div className="orange-color-input display-1">
                            {" "}
                            <FormControlLabel
                              value="male"
                              control={<Radio />}
                            />
                            <p>Progress</p>
                          </div> */}

                          <FormControlLabel
                            value=""
                            control={<Radio />}
                            label="All"
                          />
                          <div className="green-color-input display-1">
                            {" "}
                            <FormControlLabel
                              value="Completed"
                              control={<Radio />}
                              label="Completed"
                            />
                          </div>
                          <div className="orange-color-input display-1">
                            {" "}
                            <FormControlLabel
                              value="In-progress"
                              control={<Radio />}
                              label="Progress"
                            />
                          </div>
                        </RadioGroup>
                      </div>
                    </Grid2>
                  </Grid2>
                </Grid2>
                <Grid2 item size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
                  <Stack
                    direction="row"
                    sx={{ justifyContent: "end" }}
                    className="search-history-input"
                  >
                    <div className="input-common">
                      <TextField
                        size="small"
                        placeholder="Search History"
                        value={searchValue}
                        className="search-bar"
                        onChange={(e) => setSearchValue(e.target.value)}
                        InputProps={{
                          endAdornment: (
                            <IconButton onClick={handleSearch}>
                              <SearchIcon />
                            </IconButton>
                          ),
                        }}
                      />
                    </div>
                  </Stack>
                </Grid2>

                <Grid2
                  item
                  size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                  className="mb-20"
                >
                  <div className="ContactListTable-main">
                    <TableContainer
                      component={Paper}
                      sx={{ maxHeight: 440, borderRadius: "20px 20px 0px 0px" }}
                    >
                      <Table
                        sx={{ minWidth: 700 }}
                        stickyHeader
                        aria-label="sticky table"
                      >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell align="center">
                              SI.No
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Name
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Created At
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Total Users
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Status
                            </StyledTableCell>
                            <StyledTableCell align="center"></StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {displayedRows.length > 0 ? (
                            displayedRows.map((row, index) => (
                              <StyledTableRow key={row.name}>
                                <StyledTableCell component="th" align="center">
                                  <Link to="/contact-list-view">
                                    <h4>{index + 1} </h4>{" "}
                                  </Link>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4>{row.name}</h4>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4>{row.created}</h4>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4>{row.totalContacts}</h4>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  <h4 className="green">{row.status}</h4>
                                </StyledTableCell>{" "}
                                {/*color for orange text => className="orange" */}
                                <StyledTableCell
                                  align="center"
                                  onClick={() =>
                                    navigate("/campaign-overview", {
                                      state: {
                                        id: row?.id,
                                        name: row?.name,
                                        status: row?.status,
                                      },
                                    })
                                  }
                                >
                                  {" "}
                                  <Link
                                    to="/campaign-overview"
                                    className="View Details"
                                  >
                                    {" "}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="15"
                                      viewBox="0 0 16 15"
                                      fill="none"
                                    >
                                      <g clip-path="url(#clip0_904_10527)">
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M1.51953 12.7613C2.93107 10.8946 4.18453 9.83542 5.27992 9.58375C6.3753 9.33208 7.41819 9.29406 8.40857 9.46969L8.40857 12.8125L13.058 7.35781L8.40857 2.1875L8.40857 5.36469C6.57722 5.38031 5.0203 6.09208 3.7378 7.5C2.45568 8.90792 1.71626 10.6617 1.51953 12.7613Z"
                                          fill="white"
                                          stroke="white"
                                          stroke-width="1.76471"
                                          stroke-linejoin="round"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_904_10527">
                                          <rect
                                            width="14.4231"
                                            height="15"
                                            fill="white"
                                            transform="translate(0.878906)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    View Details
                                  </Link>
                                </StyledTableCell>
                              </StyledTableRow>
                            ))
                          ) : (
                            <StyledTableRow style={{ height: 100 }}>
                              <label style={{ textAlign: "center" }}>
                                No data found!
                              </label>
                            </StyledTableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <div className="Pagination-main">
                    {/* <TablePagination
          rowsPerPageOptions={[5,10,25]} // Available options for rows per page
          component="div"
          count={totalPages * rowsPerPage} // Total items count (totalPages * rowsPerPage)
          rowsPerPage={rowsPerPage} // Rows per page state
          page={page} // Current page (0-based index)
          onPageChange={handleChangePage} // Handle page change
          onRowsPerPageChange={handleChangeRowsPerPage} // Handle rows per page change
        /> */}
          {filteredCampaignList.length > 5 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredCampaignList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
                    </div>
                  </div>
                </Grid2>
              </Grid2>
            {/* </Box> */}
          {/* </Box> */}
        </div>
      ) : (
        <div className="Campaign">
          {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
            <SideBar />

            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: isLgUp ? 5 : 1,
                width: { sm: `calc(100% - ${drawerWidth}px)` },
                marginTop: isLgUp ? "50px" : "80px",
              }}
            > */}
              <Grid2 container spacing={2}>
                <Grid2
                  item
                  size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                  className="mb-20"
                >
                  <div className="create-assitant">
                    <h1>Start Your First Campaign</h1>
                    <p>
                      Creating campaigns will help you accomplish your goals,
                      Such as lead generations.
                    </p>

                    <div className="modal-popup">
                      <div className="graient-btn mt-30">
                        <Link to={"/Create-campaign"}>
                          <Button className="display-1" onClick={handlePopOpen}>
                            CREATE NEW CAMPAIGN <AddIcon />
                          </Button>
                        </Link>
                      </div>
                      <Modal
                        open={pop}
                        onClose={handlePopClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box className="common-modal-box">
                          .display-2 .display-2
                          <div className="assistant-cnt">
                            <div className="input-common mt-20">
                              <label> Name *</label>
                              <TextField fullWidth id="fullWidth" />
                            </div>
                            <div className="input-common mt-20">
                              <label>Description (optional) *</label>
                              <TextField
                                multiline
                                rows={5}
                                fullWidth
                                id="fullWidth"
                              />
                            </div>
                          </div>
                          <Stack
                            direction="row"
                            spacing={2}
                            sx={{ justifyContent: "center" }}
                            className="mt-20"
                          >
                            <div className="border-graient mt-10">
                              <Button>Cancel</Button>
                            </div>
                            <div className="border-graient gradient-bg mt-10">
                              <Button
                                onClick={() => {
                                  navigate("/contact-list-table");
                                }}
                              >
                                Save
                              </Button>
                            </div>
                          </Stack>
                        </Box>
                      </Modal>
                    </div>
                  </div>
                </Grid2>
              </Grid2>
            {/* </Box>
          </Box> */}
        </div>
      )}
    </div>
  );
};

export default Campaign;
